@if (batch) {
  <div class="card">
    <div class="card-body p-3">
      <p class="h6 badge badge-pill badge-warning">Lote {{ batchIndex + 1 }}</p>
      @if (batch.pdv_only) {
        <p class="p"><strong>Tipo do lote:</strong> Portaria</p>
      }
      @if (management && batch.id) {
        @if (batch.can_transition && batch.next_batch_number !== null && batch.next_batch_number !== undefined) {
          <button
            type="button"
            class="btn btn-outline-primary mb-2"
            data-testid="transition-batch"
            [disabled]="transitionPending || !!transitionDisabledReason"
            (click)="requestTransition()">
            Virar para o próximo lote
          </button>
          @if (transitionDisabledReason) {
            <p class="text-secondary">{{ transitionDisabledReason }}</p>
          }
        } @else if (batch.transition_block_reason) {
          <p class="text-secondary">{{ batch.transition_block_reason }}</p>
        }
      }
      <p class="p d-flex flex-wrap gap-1">
        <strong>Início das Vendas</strong>
        {{ batch.sale_start ? (batch.sale_start | date: "short") : "Aguarda o lote anterior" }}
      </p>
      <p class="p d-flex flex-wrap gap-1">
        <strong>Virada do lote</strong>
        {{ batch.transition_mode === "sold_out_only" ? "Somente por esgotamento" : "Por data ou esgotamento" }}
      </p>
      <p class="p d-flex flex-wrap gap-1">
        <strong>Fim das Vendas</strong>
        {{
          batch.transition_mode === "sold_out_only"
            ? (batch.pdv_only ? "Até esgotar ou até o fim do evento" : "Até esgotar ou até o início do evento")
            : (batch.sale_end | date: "short")
        }}
      </p>
      <div class="tickets-container">
        @for (ticket of batch.tickets; track ticket) {
          <div class="card">
            <div class="card-body p-3">
              <p class="h6 ticket-title">{{ ticket.title }}</p>
              <p class="p d-flex flex-wrap gap-1 text-secondary">{{ ticket.description }}</p>
              <p class="p d-flex flex-wrap gap-1">
                <strong>Valor final</strong> {{ getFinalPrice(ticket.price) | currency: "BRL" : true }}
              </p>
              <p class="p d-flex flex-wrap gap-1"><strong>Quantidade Disponível</strong> {{ ticket.quantity }}</p>
              <!-- <p class="p d-flex flex-wrap gap-1"><strong>Disponibilidade</strong> {{ ticket.availability }}</p> -->
              <p class="p d-flex flex-wrap gap-1">
                <strong>Limite por Comprador</strong> {{ ticket.min_per_buyer }} - {{ ticket.max_per_buyer }}
              </p>
              @if (canTransitionTicket(ticket)) {
                <button
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  data-testid="transition-ticket"
                  [disabled]="transitionPending || !!transitionDisabledReason"
                  (click)="requestTicketTransition(ticket)">
                  Virar ingresso
                </button>
              } @else if (management && ticketTransition(ticket)?.transition_block_reason) {
                <p class="text-secondary mt-2 mb-0">{{ ticketTransition(ticket)?.transition_block_reason }}</p>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
